export default __webpack_public_path__ + "static/media/RameshOj.b994e110.pdf";